import { render, staticRenderFns } from "./ProductQuickEditMainSupplierBuyCatalogPrice.vue?vue&type=template&id=b40799a4&scoped=true"
import script from "./ProductQuickEditMainSupplierBuyCatalogPrice.vue?vue&type=script&lang=ts"
export * from "./ProductQuickEditMainSupplierBuyCatalogPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40799a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b40799a4')) {
      api.createRecord('b40799a4', component.options)
    } else {
      api.reload('b40799a4', component.options)
    }
    module.hot.accept("./ProductQuickEditMainSupplierBuyCatalogPrice.vue?vue&type=template&id=b40799a4&scoped=true", function () {
      api.rerender('b40799a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductQuickEditMainSupplierBuyCatalogPrice.vue"
export default component.exports